export default "__VITE_ASSET__0201f898__"